import { Button, Checkbox, FormControlLabel, Grid, Grid2, Snackbar, Typography } from "@mui/material";
import TokenError from "../tokenError";
import { useEffect, useState } from "react";
import config from "../../config/config";
import { useNavigate } from "react-router-dom";
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import axios from 'axios';

const OperationalCities = () =>{
    const navigate = useNavigate();
    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [tokenExpired, setTokenExpired] = useState(false);
    const [rows, setRows] = useState([]);
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);

    const [errorMessage, setErrorMessage] = useState('');
    
    const [cityStates, setCityStates] = useState('');
    // const [initialCityStates] = useState(cityStates);
    const [initialCityStates, setInitialCityStates] = useState('');

    const handleChange = (city_id) => {
        setCityStates((prev) => ({
          ...prev,
          [city_id]: prev[city_id] === 1 ? 0 : 1, // toggle between 1 and 0
        }));
    };

    const fetchOperationalCitiesData = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/settings/fetch_client_cities';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                setRows(response.data);
                setCityStates(
                    Object.fromEntries(response.data.map(city => [city.city_id, city.is_active]))
                );
                setInitialCityStates(
                    Object.fromEntries(response.data.map(city => [city.city_id, city.is_active]))
                )
                // console.log('cities = ', response.data.filter(item => item.is_active==1))
                const citttyyy = response.data.filter(item => item.is_active==1);
                // console.log('json = ', JSON.stringify(citttyyy))

                localStorage.setItem('cities', JSON.stringify(citttyyy))
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        }
        catch (error) {
            console.log('error', error);
        }
    }

    const handleOpenAddCity = () => {
        console.log('opening...');
        navigate('./add-operational-city')
    }

    const saveCitiesData = async()=> {
        const changedCities = [];

        // if(cityStates===initialCityStates){
        //     setMessage('')
        // }

        for (const city_id in cityStates) {
            if (cityStates[city_id] !== initialCityStates[city_id]) {
                changedCities.push({
                city_id: parseInt(city_id, 10),
                is_active: cityStates[city_id],
                });
            }
        }
        const payload = {
            token: localStorage.getItem('token'),
            cities: changedCities
        }
        try {
            const url = operationsUrl + '/city/update_city_status';
            var response = await axios.post(url, payload);

            if(response.data.flag==102){
                console.log('Token is expired. Please login again')
                    localStorage.removeItem('token');
                    setErrorMessage('Your session has expired. Please log in again.');
                    setTokenExpired(true);

                    setTimeout(() => {
                        navigate('/signup');
                    }, 2000);
            }

            if (response.data.flag === 200) {
                console.log('Operational cities updated successfully', response.data.message);
                setMessage(response.data.message)
                showSnackbar(true);

            } else {
                console.error('Failed to update operational cities:', response.data.message);
                setMessage(response.data.message)
                showSnackbar(true);
            }
        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }
        fetchOperationalCitiesData();
    }

    useEffect(()=> {
        fetchOperationalCitiesData();
    },[]);

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    return(
        <div>
            {tokenExpired && (<TokenError/>)}

            <Typography style={{ fontSize: '28px', fontWeight: '500' }}>
                Operational Cities
            </Typography>

            <Grid2 container style={{ marginTop: '2%', marginBottom: '2%' }}>
                {(JSON.stringify(cityStates) !== JSON.stringify(initialCityStates)) && (
                    <Button
                        variant="contained"
                        onClick={saveCitiesData}
                        disabled={JSON.stringify(cityStates) === JSON.stringify(initialCityStates)}
                        style={{
                            width: '185px',
                            height: '50px',
                            marginRight: '1px',
                            backgroundColor: '#0065FF',
                            textTransform: 'none',
                            borderRadius: '8px',
                        }}
                    >
                        Save
                    </Button>
                )}
                

                <Button
                    variant="contained"
                    onClick={handleOpenAddCity}
                    style={{
                        width: '185px',
                        height: '50px',
                        backgroundColor: '#000000',
                        textTransform: 'none',
                        borderRadius: '8px',
                        marginLeft:'8px'
                    }}
                >
                    + Add City
                </Button>
            </Grid2>

            <Grid container spacing={2}>
                {rows.map((city, index) => (
                    <Grid item xs={12} sm={6} md={4} key={city.city_id}>
                    <FormControlLabel
                        control={
                        <Checkbox
                            checked={cityStates[city.city_id] == 1}
                            onChange={() => handleChange(city.city_id)}
                        />
                        }
                        label={city.city_name}
                    />
                    </Grid>
                ))}
            </Grid>

            <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>
            
        </div>
    )
}

export default OperationalCities;